import { useEffect } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import ChooseCommunityComponent from './ChooseCommunityComponent';

import { getCommunityList } from '../actions';

import * as commonSelectors from '../../Shared/selectors';
import * as communitySelectors from '../selectors';

const ChooseCommunityContainer = (props) => {
  const { getCommunityList, communityUnpagedList, isLoading } = props;

  useEffect(() => {
    getCommunityList({ enabled: true, disable_pagination: true });
  }, []);

  return (
    <ChooseCommunityComponent
      communityUnpagedList={communityUnpagedList}
      isLoading={isLoading}
    />
  );
};

ChooseCommunityContainer.propTypes = {
  getCommunityList: PropTypes.func.isRequired,
  communityUnpagedList: PropTypes.instanceOf(Array).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  isLoading: commonSelectors.getIsLoading(state),
  communityUnpagedList: communitySelectors.getCommunityUnpagedList(state),
});

const mapDispatchToProps = (dispatch) => ({
  getCommunityList: (queryParams) =>
    getCommunityList(dispatch, queryParams, false, true),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ChooseCommunityContainer);
